import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { formatDateWithTimeframe, formatShortDate, TimeframeType } from '../../../../utils/date-utils';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function WorkOrderDatesPanel() {

	const { order } = useContext(WorkOrderContext);

	return (
		<Panel header={'Dates'}
			className="field-label-70"
		>
			<Field label={'Customer Contact Date'} >
				{formatShortDate(order.details.customerContactDate)}
			</Field>
			<Field label={'Scheduled Date'} >
				{formatDateWithTimeframe(order.details.scheduledDate, TimeframeType.Long)}
			</Field>
			<Field label={'Work Complete Date'} >
				{formatShortDate(order.details.workCompleteDate)}
			</Field>
		</Panel>
	);
}
